import { Dispatcher } from "../common/dispatcher"
import { Event } from "../common/Emitter"
import Actions from "./LoginActions";
import EsercentiActions from "./esercentiActions";
import { AccountData, CompanyDto } from "../generated";

class LoginStore {
    private _loginStatus: AccountData | null | undefined = undefined;
    private _esercente: CompanyDto | null | undefined = undefined;
    setEsercente(result: CompanyDto): void {
        this._esercente = result;
        this.Changed.emit();
    }
    Changed: Event = new Event();
    constructor() {
        Dispatcher
            .onfunction(Actions.signOut, () => this.set(null))
            .onfunction(Actions.getAccountInfo, result => this.set(result))
            .onfunction(Actions.login, result => this.set(result))
            .onfunction(EsercentiActions.getEsercente, result => this.setEsercente(result))
            .onfunction(EsercentiActions.update, result => result && this.setEsercente(result))
    }

    get() {
        return this._loginStatus ?? null;
    }
    getEsercente() {
        return this._esercente ?? null;
    }
    isInitialized(): boolean {
        return this._loginStatus !== undefined;
    }

    set(user: AccountData | null) {
        this._loginStatus = user;
        this.Changed.emit();
    }
}

export default new LoginStore();